export default __webpack_public_path__ + "static/media/queenofpeace.c22d8905.jpg";